/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { RMWContext } from 'app/shared/providers/RMWContext';

class RMWProvider extends React.Component {
    static propTypes = {
        brand: PropTypes.string.isRequired,
        isInMobileWebView: PropTypes.bool.isRequired,
        paths: PropTypes.object.isRequired,
    };

    static getStateFromProps = props => ({
        brand: props.brand,
        isInMobileWebView: props.isInMobileWebView,
        paths: props.paths,
    });

    constructor(props) {
        super(props);
        this.state = RMWProvider.getStateFromProps(props);
    }

    render() {
        return <RMWContext.Provider value={this.state}>{this.props.children}</RMWContext.Provider>;
    }
}

export default RMWProvider;
